/* eslint-disable no-console */
import apiClient from 'ps-components/lib/apiClient';

export const GET_RECENT_JOBS_START = 'GET_RECENT_JOBS_START';
export const GET_RECENT_JOBS_SUCCESS = 'GET_RECENT_JOBS_SUCCESS';
export const GET_RECENT_JOBS_ERROR = 'GET_RECENT_JOBS_ERROR';

/*
  Get a list of the most recently updated jobs in this site and by this user
*/
export function getRecentJobs() {
  return async dispatch => {
    const errorMessage = 'Error retrieving recently updated jobs';

    try {
      dispatch({ type: GET_RECENT_JOBS_START });

      const result = await apiClient.apiGet(`/api/home/dashboard/getRecentJobs`);

      if (result.data.success) {
        dispatch({ type: GET_RECENT_JOBS_SUCCESS, jobs: result.data.jobs });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      console.log(errorMessage, error);
      dispatch({ type: GET_RECENT_JOBS_ERROR, error: errorMessage });
    }
  };
}
